import { Spin } from 'antd';

interface SpinnerProps {
  className?: string;
  size?: 'small' | 'default' | 'large';
}

export function Spinner({ className, size = 'default' }: SpinnerProps) {
  return <Spin size={size} className={className} />;
}
